import { Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { RootState } from '../../../reducers';
import { ConsentSignatureTypeEnum } from '../../../Enum/ConsentSignatureTypeEnum';
import { setDigitalSignatureForm } from '../../../store/consentSlice.slice';

const SignatureTypeTabs: React.FC<{ isSpanish: boolean }> = ({ isSpanish }) => {
    const dispatch = useAppDispatch();
    const { digitalSignatureForm } = useSelector((state: RootState) => state.consentSlice);

    const handleChangeSignatureType = (event: React.SyntheticEvent, newValue: ConsentSignatureTypeEnum) => {
        dispatch(
            setDigitalSignatureForm({
                ...digitalSignatureForm,
                SignatureType: newValue,
            })
        );
    };
    return (
        <Tabs value={digitalSignatureForm.SignatureType} onChange={handleChangeSignatureType} variant="fullWidth" sx={{ px: 2 }}>
            <Tab label={isSpanish ? 'Firma del Paciente' : 'Patient Signature'} value={0} />
            <Tab label={isSpanish ? 'Tutor Legal o Cuidador' : 'Legal Guardian or Caregiver'} value={1} />
            <Tab label={isSpanish ? 'Consentimiento Verbal' : 'Verbal Consent'} value={2} />
        </Tabs>
    );
};
export default SignatureTypeTabs;
